import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import DismissableAlert from '../components/common/DismissableAlert';
import _actions from '../actions';
import { FormWrapper } from '../components/common/FormWrapper';
import { FormHeader } from '../components/common/FormHeader';
import { FormSubmit } from '../components/common/FormSubmit';

class ThanksContainer extends Component {
  constructor(props) {
    super(props);

    const {
      sale: { sale },
      actions
    } = props;

    if (sale.id == null || sale.day == null || Object.keys(sale.packages) < 1) {
      return actions.transitionTo('/');
    }

    document.title = `Ticket for ${sale.firstName} ${sale.lastName}`;
  }
  render() {
    const { error, config, sale } = this.props;

    return (
      <FormWrapper>
        <div className="no-print">
          <FormHeader>{config.thanksHeader || ''}</FormHeader>
          <div dangerouslySetInnerHTML={{ __html: config.thanksBody || '' }} />
        </div>
        {sale.emailBody != null && sale.emailBody.trim() != '' && (
          <div className="mt3">
            <div className="no-print">
              <FormSubmit>
                <button
                  className="swformback__btn"
                  type="button"
                  onClick={() => window.print()}
                >
                  Print
                </button>
              </FormSubmit>
            </div>
            <div
              className="mt3 ticket-receipt"
              dangerouslySetInnerHTML={{ __html: sale.emailBody || '' }}
            />
          </div>
        )}
        <DismissableAlert>{error}</DismissableAlert>
      </FormWrapper>
    );
  }
}

ThanksContainer.propTypes = {
  error: PropTypes.string,
  config: PropTypes.object,
  sale: PropTypes.object,
  actions: PropTypes.object
};

const mapStateToProps = state => ({
  sale: state.sale,
  config: state.config,
  inventory: state.inventory
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ThanksContainer));
